import React, { useState } from 'react';
import classNames from 'classnames';
import { ProgressBar, Timer } from '@landtrustinc/design-system';
import config from '../../config';

import css from './CountdownWithProgressBar.module.css';

const CountdownWithProgressBar = ({
  label,
  expirationTimestamp,
  containerClassName,
  contentClassName,
  progressBarClassName,
  kind,
}) => {
  const containerClass = classNames(containerClassName || css.container);
  const contentClass = classNames(contentClassName || css.content);
  const progressBarClass = classNames(progressBarClassName || css.progressBar);

  const [progress, setProgress] = useState(0);

  // In seconds
  const totalDuration = config.packagesEarlyAccessDays * 24 * 60 * 60;

  const handleTimeUpdate = timeLeft => {
    const progressPercentage =
      totalDuration > 0 ? (timeLeft.totalSeconds / totalDuration) * 100 : 0;
    setProgress(parseInt(100 - progressPercentage, 10));
  };

  return (
    <div className={css.root}>
      <div className={css.progressBarContainer}>
        <ProgressBar progress={progress} className={progressBarClass} height="8px" kind={kind} />
      </div>

      <div className={containerClass}>
        <div className={contentClass}>
          <div className={css.label}>{label}</div>

          <div className={css.counter}>
            <Timer
              expirationTimestamp={expirationTimestamp}
              onTimeUpdate={handleTimeUpdate}
              showSeconds
              fontSize="12px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownWithProgressBar;
